import Request from "@/services/api/Request";

import { API_URL } from "@/constants";

export const routes = {
  popular: `${API_URL}/charts/popular`,
  favorite: `${API_URL}/charts/favorite`,
  genre: id => `${API_URL}/charts/genre/${id}/show`
};

export const request = new Request("charts");

export default {
  fetch(type, params = {}) {
    switch (type) {
      case "popular":
        return this.popular(params);
      case "favorite":
        return this.favorite(params);
      case "genre":
        return this.genre(params);
      default:
        return Promise.resolve({});
    }
  },
  popular(params) {
    return request.get(routes.popular, params);
  },
  favorite(params) {
    return request.get(routes.favorite, params);
  },
  genre(params) {
    const id = params.id;
    delete params.id;
    return request.get(routes.genre(id), params);
  }
};
